<template>
  <div class="container">
    <form v-if="contents">
      <div class="row">
        <div class="col s6">
          <h1>{{ $t('auto_delete') }}</h1>
          <P style="color: #e50000">*{{ $t('once_the_data_is_deleted_it_cannot_be_recovered') }}</P>
        </div>

        <div class="col s6 text-xs-right">
          <v-btn v-if="!isEditCommand" icon outline color="primary" @click="editCommand">
            <v-icon> edit </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="caption" style="margin-top: 10px">
            <div class="primary--text" style="color: #515151">{{ $t('customer_data') }}</div>
          </div>
          <div class="caption" style="margin-top: 10px">
            {{ $t('customer_detail') }}
          </div>
          <div
            style="margin-top: 10px; width: 150px"
            class="form-control"
            :class="{ 'has-error': errors.has('customer_data') }"
          >
            <div v-if="isEditCommand" style="display: flex; align-items: baseline">
              <input
                v-model="delete_user_date"
                v-validate="{ required: true, min_value: 1 }"
                class="input"
                name="customer_data"
                type="number"
                min="1"
                oninput="validity.valid||(value='');"
              />
              <p style="padding-left: 10px">{{ $t('Day') }}</p>
            </div>
            <div v-else class="primary--text" style="margin-top: 10px">
              <h1 style="display: inline">{{ delete_user_date }}</h1>
              <p style="display: inline">{{ $t('Day') }}</p>
            </div>
            <span v-if="errors.has('customer_data')" class="text-error">{{
              $t('please_specify_at_least_15_days')
            }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="caption" style="margin-top: 10px">
            <div class="primary--text" style="color: #515151">{{ $t('chat_data') }}</div>
          </div>
          <div class="caption" style="margin-top: 10px">
            {{ $t('chat_detail') }}
          </div>
          <div
            style="margin-top: 10px; width: 150px"
            class="form-control"
            :class="{ 'has-error': errors.has('chat_data') }"
          >
            <div v-if="isEditCommand" style="display: flex; align-items: baseline">
              <input
                v-model="delete_chatlog_date"
                v-validate="{ required: true, min_value: 1 }"
                class="input"
                name="chat_data"
                type="number"
                min="1"
                oninput="validity.valid||(value='');"
              />
              <p style="padding-left: 10px">{{ $t('Day') }}</p>
            </div>

            <div v-else class="primary--text" style="margin-top: 10px">
              <h1 style="display: inline">{{ delete_chatlog_date }}</h1>
              <p style="display: inline">{{ $t('Day') }}</p>
            </div>
            <span v-if="errors.has('chat_data')" class="text-error">{{
              $t('please_specify_at_least_15_days')
            }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="caption" style="margin-top: 10px">
            <div class="primary--text" style="color: #515151">{{ $t('ticket_data') }}</div>
          </div>
          <div class="caption" style="margin-top: 10px">
            {{ $t('ticket_detail') }}
          </div>
          <div
            style="margin-top: 10px; width: 150px"
            class="form-control"
            :class="{ 'has-error': errors.has('ticket_data') }"
          >
            <div v-if="isEditCommand" style="display: flex; align-items: baseline">
              <input
                v-model="delete_ticket_date"
                v-validate="{ required: true, min_value: 1 }"
                class="input"
                name="ticket_data"
                type="number"
                min="1"
                oninput="validity.valid||(value='');"
              />
              <p style="padding-left: 10px">{{ $t('Day') }}</p>
            </div>
            <div v-else class="primary--text" style="margin-top: 10px">
              <h1 style="display: inline">{{ delete_ticket_date }}</h1>
              <p style="display: inline">{{ $t('Day') }}</p>
            </div>
            <span v-if="errors.has('ticket_data')" class="text-error">{{
              $t('please_specify_at_least_15_days')
            }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-control">
            <div v-if="isEditCommand" class="caption" style="margin-top: 10px">
              <div class="primary--text" style="color: #515151">
                {{ $t('enable_the_automatic_data_deletion_function') }}
              </div>
              <label
                class="toggle-switch small"
                style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
              >
                <input
                  type="checkbox"
                  :checked="auto_delete_mode"
                  @change="auto_delete_mode = !auto_delete_mode"
                />
                <span class="toggle-slider lever round"></span>
              </label>
            </div>
            <div v-else class="primary--text" style="margin-top: 10px"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-control">
            <div v-if="isEditCommand" class="caption" style="margin-top: 10px">
              <v-checkbox
                v-model="enabled"
                hide-details
                color="primary"
                :label="$t('i_have_read_and_accepted_the_terms_shown')"
              ></v-checkbox>
            </div>
            <div v-else class="primary--text" style="margin-top: 10px"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div
          style="text-align: center; display: inline-flex; justify-content: center"
          class="col s12"
        >
          <div v-if="isEditCommand" style="display: flex">
            <v-btn color="grey" :disabled="loading" outline @click="cancel">{{
              $t('cancel')
            }}</v-btn>
            <v-btn color="primary" :disabled="!enabled" @click="handleSave">
              {{ $t('Save') }}</v-btn
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import settingApi from '@/api/setting'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'

export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      delete_user_date: '',
      delete_chatlog_date: '',
      delete_ticket_date: '',
      dialog: false,
      enabled: false,
      loading: false,
      cache: '',
      isEditCommand: false,
      auto_delete_mode: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      contents: 'getSetting'
    })
  },
  async created() {
    await this.$store.dispatch('loadSetting')
    this.getConfigDeleteUser()
  },

  methods: {
    getConfigDeleteUser() {
      const vm = this
      try {
        let configDeleteUser = ''
        if (
          vm.contents &&
          vm.contents.config_delete_users_chatlog_ticket &&
          vm.contents.config_delete_users_chatlog_ticket.contentvalue
        ) {
          configDeleteUser = JSON.parse(vm.contents.config_delete_users_chatlog_ticket.contentvalue)
          vm.delete_user_date = configDeleteUser.delete_user_date
          vm.delete_chatlog_date = configDeleteUser.delete_chatlog_date
          vm.delete_ticket_date = configDeleteUser.delete_ticket_date
          vm.auto_delete_mode = configDeleteUser.auto_delete_mode
        }
      } catch (error) {
        console.error(error)
      }
    },

    async handleSave() {
      const Isvalid = await this.$validator.validateAll()
      if (!Isvalid) {
        this.goToErrorInput()
        return false
      }

      const result = await this.$swal.fire({
        html: `<h1 style="color: black; text-align: center; margin: 10px">${this.$t(
          'you_confirm_to_save_the_settings'
        )}</h1><h1 style="text-align: center; margin: 0">${this.$t(
          'automatic_data_deletion'
        )}<span style="display: inline; color: black">${this.$t(
          'or_not'
        )}</span></h1><p style="color: #e50000; text-align: center; margin: 10px">* ${this.$t(
          'once_the_data_is_deleted_it_cannot_be_recovered'
        )}</p>`,
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
        showCancelButton: true
      })
      if (result.value) {
        const response = await this.autoDelete()
        if (response && response.status == 200) {
          this.$swal.fire({
            html: `<h1 style="color: black;">${this.$t('Success')}</h1>`,
            type: 'success'
          })
          this.isEditCommand = false
        }
      }
    },
    async autoDelete() {
      try {
        const data = {
          pageid: this.selectedBot.pageid,
          adminid: this.$store.state.userid,
          edit_event: {
            delete_user_date: this.delete_user_date,
            delete_chatlog_date: this.delete_chatlog_date,
            delete_ticket_date: this.delete_ticket_date,
            auto_delete_mode: this.auto_delete_mode
          }
        }
        this.$store.dispatch('loading')
        const response = await settingApi.postConfigDeleteUser({
          data: data
        })
        this.$store.dispatch('loading')
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        this.$store.dispatch('loading')
        console.error(error)
      }
    },
    cancel() {
      this.isEditCommand = false
    },
    editCommand() {
      this.isEditCommand = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/SettingDeleteUser.vue